export default __webpack_public_path__ + "static/media/logo9.840c8fc5.png";